export default "__VITE_ASSET__Q5E5$Hg5__";